
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-is-guitar-string-tension.en",
      function () {
        return require("private-next-pages/what-is-guitar-string-tension.en.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-is-guitar-string-tension.en"])
      });
    }
  